<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Datum změny
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormattingHours(updatedAt) || missingValueString }}
      </v-col>
    </v-row>

    <ReservedCapacityForm
      :individualCapacityChangeMonthly = individualCapacityChangeMonthly
    />
  </v-card-text>
</template>

<script>
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';
import ReservedCapacityForm from '@/components/ReservedCapacityForm.vue';

export default {
  name: 'IndividualCapacityChangeMonthlyInsertedValues',
  mixins: [formatPhoneNumber],
  props: {
    individualCapacityChangeMonthly: {
      type: Object,
      required: false,
    },
    updatedAt: {
      type: String,
      required: false,
    },
  },
  components: {
    ReservedCapacityForm,
  },
  data() {
    return {
      colors: {
        actual: '#c6d8f0',
        NEW: '#fff',
        cantEdit: '#d8d8d8',
      },
    };
  },
};
</script>
